export default {
  "slots": {
    "root": "my-5",
    "trigger": "text-base"
  }
}